// extracted by mini-css-extract-plugin
export var button = "_96-7";
export var buttonRow = "_96-6";
export var fadeIn = "_96-1";
export var gradient = "_96-0";
export var panel = "_96-2";
export var panelIn = "_96-3";
export var subtitle = "_96-5";
export var title = "_96-4";